import React from "react";
import toast from "react-hot-toast";
import styles from "../../styles/ContentList.module.scss";
import { CONTENT_DEEPLINK_ACTIONS } from "../../store/constants";
import { hitContentDeeplinkNew } from "../../helpers/hitContentDeeplink";
import hitStoragePermissionRequiredAction from "../../helpers/handleStoragePermissions";
import { formatPracticeTestTimeRange } from "../../helpers/formatPracticeTestDateTime";


const PracticeTestContent = ({ content }) => {

    const handleClickAttemptTest = () => {
        const endTimeTimestamp = content?.endTime ? new Date(content.endTime).getTime() : null;
        if (!content?.isAttempted && endTimeTimestamp && Date.now() > endTimeTimestamp) {
            toast.error("Test time is end");
            return;
        }
        hitStoragePermissionRequiredAction(hitDeeplink, content);
    }


    const  hitDeeplink = (contentObj)=> {
        hitContentDeeplinkNew(
            CONTENT_DEEPLINK_ACTIONS.ACTION_TEST_ATTEMPT,
            contentObj,
            true,
            true,
            contentObj.URL
          );
    }

    return (
        <div className={styles.contentList__item__content__practiceTest}>
            {content?.startTime && content?.endTime && (
                <div className={styles.contentList__item__content__practiceTest__time}>
                   
                    <p>{formatPracticeTestTimeRange(content?.startTime)}</p>
                    <p>{formatPracticeTestTimeRange(content?.endTime)}</p>
                </div>
            )}
        <button className={styles.contentList__item__content__practiceTest__button} onClick={handleClickAttemptTest}>
            {content?.isAttempted ? "View Report" : "Attempt Test"}
        </button>
        </div>
    );
};

export default PracticeTestContent;
